module.exports = __webpack_public_path__ + "img/header-weddingRingsMen.c974418.jpg";